<template>
<button
  v-if="$can('events.print.terms')"
  @click="handleDocumentsPrint()"
  class="btn btn-fill btn-wd btn-default btn-block btn-router"
>
  Imprimir Protocolos de Entrega
</button>
</template>

<script>
import swal from 'sweetalert2'
import { mapGetters } from 'vuex'

export default {
  name: 'BtnPrintTerms',

  computed: {
    ...mapGetters('tickets', {
      tickets: 'winnersWithoutStock'
    }),
    ...mapGetters('events', {
      event: 'event'
    }),
    countTicketsWinnersWithoutStock () {
      return this.tickets.length
    }
  },

  methods: {
    handleDocumentsPrint () {
      if (this.countTicketsWinnersWithoutStock !== 0) {
        this.swalNotifyTicketWithoutStock()
      } else {
        let routeData = this.$router.resolve({
          name: 'documents.print',
          params: {
            eventId: this.event._id,
            ticketId: 'none'
          }
        })
        window.open(
          routeData.href,
          'documentsWindow',
          'menubar=false,location=false,resizable=false,scrollbars=1,status=false'
        )
      }
    },

    swalNotifyTicketWithoutStock () {
      return swal({
        title: '',
        text: `Para imprimir os documentos, todos os tickets devem ter estoque.`,
        type: 'error',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Events/Actions/BtnPrintTerms.vue